export default "__VITE_ASSET__Cl$UQx4l__"